import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import Request from './request';

export const apiGetDesktopReviewJobs = async (filters = {}) => {
  return Request.call({
    url: `/micro/desktop-review/jobs`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params: filters
  });
};
export const apiAddDesktopReviewJob = async (data = {}) => {
  return Request.call({
    url: `/micro/desktop-review/jobs`,
    method: 'POST',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data
  });
};
export const apiGetDesktopReviewJobDocuments = async (jobId) => {
  return Request.call({
    url: `/micro/desktop-review/jobs/${jobId}/documents`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetDesktopReviewJobTestPlans = async (jobId, filters = {
  pageNo: 1,
  pageSize: 1000
}) => {
  return Request.call({
    url: `/micro/desktop-review/jobs/${jobId}/test-plans`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params: filters
  });
};
export const apiGetDesktopReviewJobSummary = async (jobId) => {
  return Request.call({
    url: `/micro/desktop-review/jobs/${jobId}/summary`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetDesktopReviewJob = async (jobId) => {
  return Request.call({
    url: `/micro/desktop-review/jobs/${jobId}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiUpdateDesktopReviewJob = (jobId, data) => {
  return Request.call({
    url: `/micro/desktop-review/jobs/${jobId}`,
    method: 'PUT',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data,
  });
};
export const apiUpdateDesktopReviewJobtatus = (jobId, status) => {
  return Request.call({
    url: `/micro/desktop-review/jobs/${jobId}/status`,
    method: 'PUT',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    data: {
      status,
    },
  });
};